import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import { peritosService } from '../services/peritosService';

GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.mjs`;

// Construye un mapa etiqueta → valor siguiente no vacío a partir del array de ítems del PDF
function buildMap(items) {
  const strs = items.map(i => i.str);
  const map  = {};
  for (let i = 0; i < strs.length; i++) {
    const s = strs[i].trim();
    if (s.endsWith(':')) {
      // Buscar el siguiente ítem no vacío
      for (let j = i + 1; j < strs.length; j++) {
        const val = strs[j].trim();
        if (val && !val.endsWith(':')) {
          map[s] = val;
          break;
        } else if (val.endsWith(':')) {
          break; // siguiente etiqueta sin valor
        }
      }
    }
  }
  return map;
}

function parsearFecha(str) {
  if (!str) return '';
  const MESES = { enero:1, febrero:2, marzo:3, abril:4, mayo:5, junio:6,
                  julio:7, agosto:8, septiembre:9, octubre:10, noviembre:11, diciembre:12 };
  const m = str.match(/(\d+)\s+de\s+(\w+)\s+de\s+(\d{4})/i);
  if (!m) return '';
  const mes = MESES[m[2].toLowerCase()];
  return mes ? `${m[3]}-${String(mes).padStart(2,'0')}-${String(m[1]).padStart(2,'0')}` : '';
}

// Ítem que sigue a una etiqueta específica, buscando en el array original
function siguiente(items, etiqueta) {
  const idx = items.findIndex(i => i.str.trim() === etiqueta);
  if (idx === -1) return '';
  for (let j = idx + 1; j < items.length; j++) {
    const val = items[j].str.trim();
    if (val && !val.endsWith(':')) return val;
    if (val.endsWith(':')) break;
  }
  return '';
}

export default async function parsearAvisoPdf(file) {
  const arrayBuffer = await file.arrayBuffer();
  const pdf   = await getDocument({ data: arrayBuffer }).promise;
  const page  = await pdf.getPage(1);
  const content = await page.getTextContent();
  const items = content.items;

  const m = buildMap(items);

  // Titular: ASEGURADO tiene precedencia
  const titular = siguiente(items, 'ASEGURADO:') || siguiente(items, 'TOMADOR:');

  // Domicilio: DIRECCIÓN DEL RIESGO:
  const domicilio = siguiente(items, 'DIRECCIÓN DEL RIESGO:');

  // Localidad
  const localidad = m['POBLACIÓN:'] || '';

  // Teléfono 1 del titular: TELÉFONO PERSONA CONTACTO
  const telefono1 = siguiente(items, 'TELÉFONO PERSONA CONTACTO:') || '';

  // Notas: ítem que sigue a COMENTARIOS DEL SINIESTRO:
  const notas = siguiente(items, 'COMENTARIOS DEL SINIESTRO:');

  // nSiniestro y póliza
  const nSiniestro = siguiente(items, 'N. SINIESTRO:');
  const codPoliza  = siguiente(items, 'PÓLIZA:');

  // Fecha
  const fechaAsignacion = parsearFecha(siguiente(items, 'FECHA DE ASIGNACIÓN:'));

  // Perito: extraer nombre del PDF y buscar en BD por nombre o apellidos
  const peritoRaw = siguiente(items, 'PERITO:');
  let perito      = peritoRaw;
  let peritoMovil = '';
  if (peritoRaw) {
    try {
      // Buscar con el primer "word" del nombre (ej: "LOEN" de "LOEN (PRD - SEVILLA)")
      const termino = peritoRaw.split(/[\s(]/)[0];
      const res = await peritosService.listar(termino, 0, 5);
      const lista = res.data?.content || [];
      if (lista.length > 0) {
        const p = lista[0];
        perito      = [p.nombre, p.apellidos].filter(Boolean).join(' ');
        peritoMovil = p.movil || p.telefono || '';
      }
    } catch {
      // Si falla la búsqueda dejamos el nombre del PDF
    }
  }

  return {
    nSiniestro,
    codPoliza,
    titular,
    domicilio,
    localidad,
    perito,
    peritoMovil,
    telefono1,
    telefono2:       '',
    fechaAsignacion,
    notas,
  };
}
